import { CSSProperties, forwardRef, PropsWithChildren, ReactNode, Ref } from 'react';
import { TypographyProps, TypographyVariants } from './types';
import { fontWeightClassName, fontWeights } from './font-weights';
import classNames from 'classnames';
import { getTypographyClassNames } from './helpers';
import { TestAttributes } from '@va/types/component';

export type DivProps<T extends keyof TypographyVariants = 'interface'> = TestAttributes &
  TypographyProps<T> & {
    id?: string;
    weight?: fontWeights;
    colorClassName?: string;
    className?: string;
    children: ReactNode;
    style?: CSSProperties;
  };

export const StyledDiv = forwardRef(
  <T extends keyof TypographyVariants>(
    {
      id,
      weight = fontWeights.normal,
      colorClassName,
      variant,
      variantSize,
      className,
      children,
      style,
      ...rest
    }: PropsWithChildren<DivProps<T>>,
    ref: Ref<HTMLDivElement>,
  ) => {
    const classes = classNames(
      'font-primary',
      fontWeightClassName(weight),
      getTypographyClassNames({ variant, variantSize }),
      colorClassName,
      className,
    );

    return (
      <div {...rest} id={id} ref={ref} style={style} className={classes}>
        {children}
      </div>
    );
  },
);
